var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"audio-player",class:_vm.classObject},[_c('audio',{ref:"audio",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }